import React from "react";
import PropTypes from "prop-types";

import TextField from "@mui/material/TextField";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  root: ({ widthField }) => ({
    width: widthField,
    marginTop: "20px",
    height: 40,
    backgroundColor: "#004990",
  }),
}));

export default function InputTextField({
  id,
  text,
  placeholder,
  type,
  value,
  onChange,
  required,
  variant,
  widthField,
  name,
  customStyles,
}) {
  const classes = useStyles({ widthField });

  return (
    <TextField
      id={id}
      label={text}
      type={type}
      name={name}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      required={required}
      color="white"
      variant={variant}
      className={classes.root}
      sx={customStyles}
    />
  );
}

InputTextField.defaultProps = {
  id: "",
  required: false,
  variant: "standard",
  widthField: "100%",
  onChange: () => null,
  customStyles: {},
};

InputTextField.propTypes = {
  id: PropTypes.string,
  type: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  widthField: PropTypes.string,
  onChange: PropTypes.func,
  required: PropTypes.bool,
  variant: PropTypes.string,
  customStyles: PropTypes.object,
};
